import { render, staticRenderFns } from "./progress_announcement.vue?vue&type=template&id=02f3537c&scoped=true&"
import script from "./progress_announcement.vue?vue&type=script&lang=js&"
export * from "./progress_announcement.vue?vue&type=script&lang=js&"
import style0 from "./progress_announcement.vue?vue&type=style&index=0&id=02f3537c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f3537c",
  null
  
)

export default component.exports